/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Secure_3Inputs */

const en_pc_tut_secure_3 = /** @type {(inputs: Pc_Tut_Secure_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Author restrictions show a clear notice and are honored. Enter the owner password to lift them; your edits stay encrypted.`)
};

const zh_pc_tut_secure_3 = /** @type {(inputs: Pc_Tut_Secure_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作者设置的限制会有明确提示并被遵守。输入所有者密码即可解除，编辑后的文件仍保持加密。`)
};

/**
* | output |
* | --- |
* | "Author restrictions show a clear notice and are honored. Enter the owner password to lift them; your edits stay encrypted." |
*
* @param {Pc_Tut_Secure_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_secure_3 = /** @type {((inputs?: Pc_Tut_Secure_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Secure_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_secure_3(inputs)
	return zh_pc_tut_secure_3(inputs)
});
export { pc_tut_secure_3 as "pc.tut.secure.3" }